import {
  AtlasBodySubtitle,
  ConfirmationDialogMolecule
} from '@justomx/atlas-components'
import { useState, type MutableRefObject } from 'react'
import styled from 'styled-components'
import { RadioButtonMolecule } from 'components/molecule/RadioButton.molecule'
import type { GenericOption } from 'types/commons/model'

interface OptionsDialogProps {
  dialogRef: MutableRefObject<HTMLDialogElement | null>
  title: string
  options: GenericOption[]
  defaultOption?: string
  confirmLabel?: string
  cancelLabel?: string
  confirmAction: (value: string) => void
}

const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
`

export const OptionsDialogOrganism = (props: OptionsDialogProps) => {
  const {
    dialogRef,
    title,
    options,
    defaultOption,
    confirmLabel = 'Continuar',
    cancelLabel = 'Cancelar',
    confirmAction
  } = props
  const [selectedOption, setSelectedOption] = useState(defaultOption)

  const onChangeOption = (value: string) => {
    setSelectedOption(value)
  }

  return (
    <ConfirmationDialogMolecule
      dialogRef={dialogRef}
      confirmText={confirmLabel}
      onConfirm={confirmAction}
      cancelText={cancelLabel}
      value={selectedOption}
      confirmDisabled={!selectedOption}
    >
      <AtlasBodySubtitle>{title}</AtlasBodySubtitle>

      <DialogBody>
        {options.map((option) => (
          <RadioButtonMolecule
            name="missingType"
            key={option.id}
            id={option.id}
            value={option.id}
            label={option.label}
            defaultChecked={selectedOption === option.id}
            onChange={onChangeOption}
          />
        ))}
      </DialogBody>
    </ConfirmationDialogMolecule>
  )
}
